// const url = 'http://wwj.jijiagames.com/web/act/';

export default {
    xian: [
        {
            width: 654,
            height: 470,
            icon: '/img/guessDifferent/xian_01_icon.png',
            topPic: '/img/guessDifferent/xian_01_top.png',
            bottomPic: '/img/guessDifferent/xian_01_bottom.png',
            passPic: '/img/guessDifferent/xian_01_succeed.png',
            failPic: '/img/guessDifferent/xian_01_error.png',
            correct: [
                {
                    x: 410,
                    y: 65,
                    isRight: false
                },
                {
                    x: 335,
                    y: 130,
                    isRight: false
                },
                {
                    x: 352,
                    y: 304,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: '/img/guessDifferent/xian_02_icon.png',
            topPic: '/img/guessDifferent/xian_02_top.png',
            bottomPic: '/img/guessDifferent/xian_02_bottom.png',
            passPic: '/img/guessDifferent/xian_02_succeed.png',
            failPic: '/img/guessDifferent/xian_02_error.png',
            correct: [
                {
                    x: 360,
                    y: 120,
                    isRight: false
                },
                {
                    x: 195,
                    y: 254,
                    isRight: false
                },
                {
                    x: 471,
                    y: 290,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: '/img/guessDifferent/xian_03_icon.png',
            topPic: '/img/guessDifferent/xian_03_top.png',
            bottomPic: '/img/guessDifferent/xian_03_bottom.png',
            passPic: '/img/guessDifferent/xian_03_succeed.png',
            failPic: '/img/guessDifferent/xian_03_error.png',
            correct: [
                {
                    x: 435,
                    y: 190,
                    isRight: false
                },
                {
                    x: 280,
                    y: 226,
                    isRight: false
                },
                {
                    x: 196,
                    y: 330,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: '/img/guessDifferent/xian_04_icon.png',
            topPic: '/img/guessDifferent/xian_04_top.png',
            bottomPic: '/img/guessDifferent/xian_04_bottom.png',
            passPic: '/img/guessDifferent/xian_04_succeed.png',
            failPic: '/img/guessDifferent/xian_04_error.png',
            correct: [
                {
                    x: 192,
                    y: 67,
                    isRight: false
                },
                {
                    x: 205,
                    y: 124,
                    isRight: false
                },
                {
                    x: 381,
                    y: 358,
                    isRight: false
                }
            ]
        },
        {
            width: 398,
            height: 370,
            icon: '/img/guessDifferent/xian_05_icon.png',
            topPic: '/img/guessDifferent/xian_05_top.png',
            bottomPic: '/img/guessDifferent/xian_05_bottom.png',
            passPic: '/img/guessDifferent/xian_05_succeed.png',
            failPic: '/img/guessDifferent/xian_05_error.png',
            correct: [
                {
                    x: 160,
                    y: 70,
                    isRight: false
                },
                {
                    x: 123,
                    y: 294,
                    isRight: false
                },
                {
                    x: 270,
                    y: 331,
                    isRight: false
                }
            ]
        }
    ],
    nanhai: [
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_01_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_01_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_01_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_01_over.png',
            correct: [
                {
                    x: 120,
                    y: 87,
                    isRight: false
                },
                {
                    x: 451,
                    y: 216,
                    isRight: false
                },
                {
                    x: 195,
                    y: 219,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_02_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_02_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_02_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_02_over.png',
            correct: [
                {
                    x: 443,
                    y: 82,
                    isRight: false
                },
                {
                    x: 233,
                    y: 112,
                    isRight: false
                },
                {
                    x: 345,
                    y: 342,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_03_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_03_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_03_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_03_over.png',
            correct: [
                {
                    x: 200,
                    y: 329,
                    isRight: false
                },
                {
                    x: 411,
                    y: 342,
                    isRight: false
                },
                {
                    x: 207,
                    y: 135,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_04_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_04_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_04_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_04_over.png',
            correct: [
                {
                    x: 508,
                    y: 222,
                    isRight: false
                },
                {
                    x: 238,
                    y: 382,
                    isRight: false
                },
                {
                    x: 298,
                    y: 63,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_05_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_05_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_05_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181127/img/nanhai_05_over.png',
            correct: [
                {
                    x: 94,
                    y: 126,
                    isRight: false
                },
                {
                    x: 261,
                    y: 183,
                    isRight: false
                },
                {
                    x: 539,
                    y: 164,
                    isRight: false
                }
            ]
        }
    ],
    nanhai2: [
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_01_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_01_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_01_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_01_over.png',
            correct: [
                {
                    x: 459,
                    y: 230,
                    isRight: false
                },
                {
                    x: 483,
                    y: 118,
                    isRight: false
                },
                {
                    x: 192,
                    y: 272,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_02_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_02_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_02_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_02_over.png',
            correct: [
                {
                    x: 459,
                    y: 218,
                    isRight: false
                },
                {
                    x: 334,
                    y: 293,
                    isRight: false
                },
                {
                    x: 311,
                    y: 108,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_03_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_03_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_03_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_03_over.png',
            correct: [
                {
                    x: 485,
                    y: 150,
                    isRight: false
                },
                {
                    x: 186,
                    y: 177,
                    isRight: false
                },
                {
                    x: 428,
                    y: 301,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_04_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_04_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_04_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_04_over.png',
            correct: [
                {
                    x: 477,
                    y: 126,
                    isRight: false
                },
                {
                    x: 237,
                    y: 225,
                    isRight: false
                },
                {
                    x: 128,
                    y: 252,
                    isRight: false
                }
            ]
        },
        {
            width: 654,
            height: 470,
            icon: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_05_icon.png',
            topPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_05_top.png',
            bottomPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_05_bottom.png',
            overPic: 'http://wwj.jijiagames.com/web/act/20181219/nanhai2_05_over.png',
            correct: [
                {
                    x: 315,
                    y: 39,
                    isRight: false
                },
                {
                    x: 558,
                    y: 159,
                    isRight: false
                },
                {
                    x: 244,
                    y: 373,
                    isRight: false
                }
            ]
        }
    ],
    tianjin: {
        mainPic: '/img/guessDifferent/tianjin_main.png',
        finishPic: '/img/guessDifferent/tianjin_finish.png',
        templatePic: '/img/guessDifferent/tianjin_pic_template.png',
        info: [
            {
                width: 654,
                height: 470,
                icon: '/img/guessDifferent/tianjin_01_icon.png',
                topPic: '/img/guessDifferent/tianjin_01_top.png',
                bottomPic: '/img/guessDifferent/tianjin_01_bottom.png',
                overPic: '/img/guessDifferent/tianjin_01_over.png',
                correct: [
                    {
                        x: 327,
                        y: 83,
                        isRight: false
                    },
                    {
                        x: 328,
                        y: 178,
                        isRight: false
                    },
                    {
                        x: 283,
                        y: 347,
                        isRight: false
                    }
                ]
            },
            {
                width: 654,
                height: 470,
                icon: '/img/guessDifferent/tianjin_02_icon.png',
                topPic: '/img/guessDifferent/tianjin_02_top.png',
                bottomPic: '/img/guessDifferent/tianjin_02_bottom.png',
                overPic: '/img/guessDifferent/tianjin_02_over.png',
                correct: [
                    {
                        x: 318,
                        y: 62,
                        isRight: false
                    },
                    {
                        x: 267,
                        y: 258,
                        isRight: false
                    },
                    {
                        x: 351,
                        y: 319,
                        isRight: false
                    }
                ]
            },
            {
                width: 654,
                height: 470,
                icon: '/img/guessDifferent/tianjin_03_icon.png',
                topPic: '/img/guessDifferent/tianjin_03_top.png',
                bottomPic: '/img/guessDifferent/tianjin_03_bottom.png',
                overPic: '/img/guessDifferent/tianjin_03_over.png',
                correct: [
                    {
                        x: 187,
                        y: 150,
                        isRight: false
                    },
                    {
                        x: 491,
                        y: 157,
                        isRight: false
                    },
                    {
                        x: 359,
                        y: 236,
                        isRight: false
                    }
                ]
            },
            {
                width: 654,
                height: 470,
                icon: '/img/guessDifferent/tianjin_04_icon.png',
                topPic: '/img/guessDifferent/tianjin_04_top.png',
                bottomPic: '/img/guessDifferent/tianjin_04_bottom.png',
                overPic: '/img/guessDifferent/tianjin_04_over.png',
                correct: [
                    {
                        x: 269,
                        y: 180,
                        isRight: false
                    },
                    {
                        x: 353,
                        y: 176,
                        isRight: false
                    },
                    {
                        x: 312,
                        y: 305,
                        isRight: false
                    }
                ]
            },
            {
                width: 654,
                height: 470,
                icon: '/img/guessDifferent/tianjin_05_icon.png',
                topPic: '/img/guessDifferent/tianjin_05_top.png',
                bottomPic: '/img/guessDifferent/tianjin_05_bottom.png',
                overPic: '/img/guessDifferent/tianjin_05_over.png',
                correct: [
                    {
                        x: 402,
                        y: 48,
                        isRight: false
                    },
                    {
                        x: 234,
                        y: 190,
                        isRight: false
                    },
                    {
                        x: 320,
                        y: 262,
                        isRight: false
                    }
                ]
            }
        ]
    }
};
